import { getUserWinnerList } from '../useUpdateWinnerData';
import { getEntriesListApi } from 'api/client';

export async function setGameResultRecordsAndWinnerList(
    state,
    mergeAndDispatchState = () => {},
    isMgm = false
) {
    let userWinnerPrize = null;
    const {
        mgmRelation: { mgmReferral: { uuid: mgmPromoUUID } = {} } = {},
        promo: { uuid: promoUUID }
    } = state;

    const { payload: { items: entries = [] } = {} } = await getEntriesListApi(
        isMgm ? mgmPromoUUID : promoUUID
    );

    if (entries.length > 0) {
        userWinnerPrize = await getUserWinnerList(isMgm ? mgmPromoUUID : promoUUID);
    }

    mergeAndDispatchState(
        isMgm
            ? {
                  mgmReferral: {
                      userGameResultRecords: entries,
                      ...(Boolean(userWinnerPrize) ? { userWinnerPrize } : {})
                  }
              }
            : {
                  userGameResultRecords: entries,
                  ...(Boolean(userWinnerPrize) ? { userWinnerPrize } : {})
              }
    );
}
